import {
  Dispatch,
  SetStateAction,
  useCallback,
  useEffect,
  useState,
} from 'react'
import { ModalV2 } from '../../Modals/ModalV2'
import { useProjektprognosInteractionContext } from '../context/ProjektprognosInteractionContext'
import { Button, Tooltip } from '@fluentui/react-components'
import { Copy16Regular } from '@fluentui/react-icons'
import styles from '../../SystemState/ErrorManagement/ErrorModal.module.css'

interface ProjektprognosErrorModalProps {
  isModalOpen: boolean
  setIsModalOpen: Dispatch<SetStateAction<boolean>>
}

export const ProjektprognosErrorModal = ({
  isModalOpen,
  setIsModalOpen,
}: ProjektprognosErrorModalProps) => {
  const { errors, setErrors } = useProjektprognosInteractionContext()
  const [errorModalContent, setErrorModalContent] = useState<JSX.Element>(<></>)

  const copyButton = (text: string) => {
    const copyText = () => navigator.clipboard.writeText(text)

    return (
      <Tooltip content="Kopiera" relationship="label">
        <Button
          icon={<Copy16Regular />}
          onClick={copyText}
          appearance="subtle"
        />
      </Tooltip>
    )
  }

  const mapErrors = useCallback(() => {
    if (errors) {
      return errors.map((error, index) => (
        <div
          className={`${styles.errorMessageRow} ${
            index > 0 ? styles.errorMessageBorder : undefined
          }`}
          key={index}
        >
          <p
            className={`${styles.errorMessage} ${
              index > 0 ? styles.notFirstErrorMessage : undefined
            }`}
          >
            {error.message}
          </p>

          {copyButton(error.message)}
        </div>
      ))
    }
  }, [errors])

  const generateModalContent = useCallback(() => {
    const clearErrors = () => {
      setErrors([])
      setIsModalOpen(false)
    }

    return (
      <>
        <div className={styles.errorsContainer}>{mapErrors()}</div>
        <div className={styles.clearButton}>
          <Button appearance="primary" onClick={clearErrors}>
            Rensa fel
          </Button>
        </div>
      </>
    )
  }, [mapErrors, setErrors, setIsModalOpen])

  useEffect(() => {
    if (errors?.length > 0) {
      setErrorModalContent(generateModalContent())
    }
  }, [errors, generateModalContent])

  return (
    <>
      <ModalV2
        modalHeader="Något gick fel"
        modalContent={errorModalContent}
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
      />
    </>
  )
}
